module.exports = __webpack_public_path__ + "static/media/6460.2bbf68e3.jpg";